import { MeetingBookingRoute } from 'app/constants/Routes';
import {
  BookingId,
  BookingQueryParam,
  BookingState,
  BookingType,
  BookingTypeCodec,
} from 'app/models/rtc/booking/constants';
import { LessonBookingOutcomeType } from 'app/models/rtc/booking/lessons/outcome';
import { parseSupplementalData } from 'app/remote/response';
import { History } from 'app/services/history';
import * as io from 'io-ts';
import { stringify } from 'query-string';
import { resolveDynamicRouteInBrandDomain } from 'app/utils/brand';
import { EntityFields } from 'app/types/entity';
import { IBrandDomain } from 'app/constants/schemas/BrandDomain';
import { IdentityEntityStringIdCodec } from 'app/types/entity/codecs';

export const isBookingCancelled = (bookingState: BookingState) => {
  return bookingState.bookingType === BookingType.Lesson
    ? bookingState.outcome?.type === LessonBookingOutcomeType.Cancelled
    : false;
};

export const isBookingType = BookingTypeCodec.is;

export const createOffsiteMeetingBookingUrl = (domain: EntityFields<IBrandDomain>, id: BookingId) => {
  return resolveDynamicRouteInBrandDomain(domain, MeetingBookingRoute, { id });
};

export const createOffsiteMeetingBookingHostUrl = (
  domain: EntityFields<IBrandDomain>,
  id: BookingId,
  hostKey: string,
) => {
  const baseUrl = createOffsiteMeetingBookingUrl(domain, id);
  const query = `${stringify({ [BookingQueryParam.BookingHostKey]: hostKey })}`;
  return `${baseUrl}?${query}`;
};

export const createMeetingBookingUrl = (history: History, id: BookingId) =>
  history.createHref({
    pathname: MeetingBookingRoute.getPathname({ id }),
  });

export const createMeetingBookingHostUrl = (history: History, id: BookingId, hostKey: string) => {
  const baseUrl = createMeetingBookingUrl(history, id);
  const query = `${stringify({ [BookingQueryParam.BookingHostKey]: hostKey })}`;

  return `${baseUrl}?${query}`;
};

interface ICreateMeetingSupplementaryData {
  [index: string]: { host_key: string };
}

const CreateMeetingSupplementaryData: io.Type<ICreateMeetingSupplementaryData> =
  io.dictionary(IdentityEntityStringIdCodec, io.type({ host_key: io.string }));

export const parseSupplementaryMeetingBookingData = (result: unknown) =>
   parseSupplementalData(result, CreateMeetingSupplementaryData);
